// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"82":"15b6c7e1","418":"342961d2"}[chunkId] + ".css";
};